$(function () {

    // ウィンドウ高さ
    var windowHeight = $(window).height();
    var windowWidth = $(window).width();

    if(windowWidth <= 600){
      $(".swiper-slide.pc-only").remove();
    }
  
    if (windowWidth < 1024 || windowHeight > windowWidth){
      // ロードしない
      // preload noneを設定
      $('.exhibition-bg-movie video').removeAttr('autoplay').attr('preload', 'none');
    }
  
    // 各セクション要素位置
    var exhibitionAbout = $('#exhibition-about').offset().top;
    // var exhibitionHistory = $('#exhibition-history').offset().top;
    // var exhibitionLifestyleBlank = $('#exhibition-lifestyle-blank').offset().top;
    var exhibitionNewStore = $('#exhibition-new-store').offset().top;
    var exhibitionCollection = $('#exhibition-collection').offset().top;
    var exhibitionNewCollection01 = $('#collection01').offset().top;
    var exhibitionNewCollection02 = $('#collection02').offset().top;
    var exhibitionNewCollection03 = $('#collection03').offset().top;
    var exhibitionNewCollection04 = $('#collection04').offset().top;
    var exhibitionNewCollection05 = $('#collection05').offset().top;
    var exhibitionNewCollection06 = $('#collection06').offset().top;
    var exhibitionNewCollection07 = $('#collection07').offset().top;
    var exhibitionNewCollection08 = $('#collection08').offset().top;
    var exhibitionContents = $('#exhibition-contents').offset().top;
    var exhibitionContentsJournal = $('#exhibition-journal').offset().top;
    var exhibitionContentsCatalog = $('#exhibition-catalog').offset().top;
    // var exhibitionContentsCollab = $('#exhibition-collab').offset().top;
    var exhibitionPickup = $('#exhibition-pickup').offset().top;
    var exhibitionSpotify = $('#exhibition-spotify').offset().top;
    // var exhibitionQuery = $('#exhibition-query').offset().top;
  
    /* SIDEBAR */
    // サイドバー遷移の位置決定
    var windowSideHeight = windowHeight * 0.4;
    // サイドバー用 各セクション要素のスクロール量 topを取得
    var exhibitionSideAbout = $('#exhibition-about').offset().top - windowSideHeight;
    // var exhibitionSideNewStore = $('#exhibition-new-store').offset().top - windowSideHeight;
    // var exhibitionSideSpecialMovie = $('#exhibition-lifestyle-blank').offset().top - windowSideHeight;
    var exhibitionSideCollection = $('#exhibition-collection').offset().top - windowSideHeight;
    var exhibitionSideNewCollection = $('#collection01').offset().top - windowSideHeight;
    var exhibitionSideContents = $('#exhibition-contents').offset().top - windowSideHeight;
    var exhibitionSideCatalog = $('#exhibition-catalog').offset().top - windowSideHeight;
    // var exhibitionSideCollab = $('#exhibition-collab').offset().top - windowSideHeight;
    var exhibitionSideSpotify = $('#exhibition-spotify').offset().top - windowSideHeight;
    // var exhibitionSideQuery = $('#exhibition-query').offset().top - windowSideHeight;
    // Footerのサイドバー位置
    var exhibitionSideFooterSide = $('#exhibition-spotify').offset().top + ($(window).height() * 0.5);
    var exhibitionSideFooter = $('#exhibition-spotify').offset().top + ($(window).height() * 0.45);
  
    /* FadeIn 開始位置 */
    if(windowWidth < 1024 || windowHeight > windowWidth){
        // sp
        var windowFadeinAboutHeight = windowHeight * 0.8;
        var windowFadeinHeight = windowHeight * 0.6;
    } else {
        // pc
        var windowFadeinAboutHeight = windowHeight * 0.6;
        var windowFadeinHeight = windowHeight * 0.6;
    }
    // FadeIn開始位置 各セクション
    var exhibitionFadeinAbout = exhibitionAbout - windowFadeinAboutHeight;
    // var exhibitionFadeinSpecialMovie = exhibitionSpecialMovie - windowFadeinHeight;
    // var exhibitionFadeinHistory = exhibitionHistory - windowFadeinHeight;
    var exhibitionFadeinCollection = exhibitionCollection - windowFadeinHeight;
    var exhibitionFadeinNewStore = exhibitionNewStore - windowFadeinHeight;
    var exhibitionFadeinNewCollection01 = exhibitionNewCollection01 - windowFadeinHeight;
    var exhibitionFadeinNewCollection02 = exhibitionNewCollection02 - windowFadeinHeight;
    var exhibitionFadeinNewCollection03 = exhibitionNewCollection03 - windowFadeinHeight;
    var exhibitionFadeinNewCollection04 = exhibitionNewCollection04 - windowFadeinHeight;
    var exhibitionFadeinNewCollection05 = exhibitionNewCollection05 - windowFadeinHeight;
    var exhibitionFadeinNewCollection06 = exhibitionNewCollection06 - windowFadeinHeight;
    var exhibitionFadeinNewCollection07 = exhibitionNewCollection07 - windowFadeinHeight;
    var exhibitionFadeinNewCollection08 = exhibitionNewCollection08 - windowFadeinHeight;
    var exhibitionFadeinContents = exhibitionContents - windowFadeinHeight;
    var exhibitionFadeinContentsJournal = exhibitionContentsJournal - windowFadeinHeight;
    // var exhibitionFadeinContentsCollab = exhibitionContentsCollab - windowFadeinHeight;
    var exhibitionFadeinContentsCatalog = exhibitionContentsCatalog - windowFadeinHeight;
    var exhibitionFadeinPickup = exhibitionPickup - windowFadeinHeight;
    var exhibitionFadeinSpotify = exhibitionSpotify - windowFadeinHeight;
    // var exhibitionFadeinQuery = exhibitionQuery - windowFadeinHeight;
  
    /* FadeOut 開始位置 */
    // Fadeout開始位置
    var exhibitionFadeoutAbout = exhibitionAbout + (windowHeight * 0.1);
    // var exhibitionFadeoutFirstLifeStyle = $("#exhibition-lifestyle").offset().top;
  
    // スクロールバーFadeout
    var fadeoutScrollBar = {
        "opacity" : 0,
        "transition" : "all 500ms"
    }
  
    // TOP タイトル固定
    var exhibitionTopTitle = (($(window).height() - $(".exhibition-top-wrapper").height())/2);
    var exhibitionTopTitle_props = {
        'position': "fixed",
        "top" : exhibitionTopTitle
    }

    // LIFESTYLE タイトル固定
    var exhibitionLifestyleTitle = (($(window).height() - $(".exhibition-lifestyle-blank-fixed").height())/2);
    var exhibitionLifeStyleTitle_props = {
        'position': "fixed",
        "top" : exhibitionLifestyleTitle,
        "opacity": 1
    }
  
    var exhibitionAboutTitlePosition = $('#exhibition-about-title').offset().top - exhibitionTopTitle;
    // var exhibitionLifestyleTitlePosition = $('.exhibition-lifestyle-subtitle-second').offset().top - exhibitionLifestyleTitle;

    // TOPアニメーション
    setTimeout(function () {
      $('.exhibition-top-title1').addClass('scrollin');
    }, 1000);
    setTimeout(function () {
        $('.exhibition-top-title2').addClass('scrollin');
    }, 1200);
    setTimeout(function () {
        $('.exhibition-top-title3').addClass('scrollin');
    }, 1400);
    setTimeout(function () {
        $('.exhibition-top-title4').addClass('scrollin');
    }, 1600);
    setTimeout(function () {
        $('.exhibition-top-title5').addClass('scrollin');
    }, 1800);
  
    // 変数
    var hasBlur_props={
      "background-color": "rgba(0,0,0,0.6)",
      "transition": "all 1000ms"
    }
    var hasWhite_props={
      "background-color": "white",
      "background-image": "unset"
    }
    var hasBg_props={
      "background-image": "url(https://cdn.shopify.com/s/files/1/0374/4792/5891/t/5/assets/exhibitionmovieimg4.png)",
      "background-size": "cover",
      "filter": "brightness(0.6)",
      "background-position": "center"
    }
  
    // scroll時に使用するdomのキャッシュ
    var $pcHeader = $('.pc-header');
    var $spHeader = $('.sp-header');
    var $spHeaderHmbgOpener = $('.sp-header .exhibition-language-header-right .dl-header__hbgicon');
    var $languageButton = $('#exhibition-language');
    var $languageIcon = $('.exhibition-language-icon-svg g g path');
    var $logoIcon = $('.exhibition-language-header-left svg');
    var $languageText = $('.exhibition-language-text');
    var $scrollBar = $('.exhibition-scrollbar');
    var $lifestyleBackground = $("#exhibition-lifestyle-bg");
    var $topWrapper = $('.exhibition-top-wrapper');
    var $aboutWrapper = $('#exhibition-about .exhibition-about-wrapper');
    var $aboutBox = $('.exhibition-about-box');
    // var $specialMovie = $(".exhibition-special-movies");
    // var $historyFadeIn = $(".exhibition-history-fadein");
    var $newStore = $(".exhibition-new-store");
    // var $lifestyleBlankWrapper = $(".exhibition-lifestyle-blank-fixed")
    // var $lifestyleSecondBox = $(".exhibition-lifestyle-box-second")
    var $ncRightWrapper = $('.exhibition-nc-right-wrapper');
    var $sidebar = $('.exhibition-sidebar');
    var $sidebarLi = $('.exhibition-sidebar ul li');
    var $sidebarLiSpan = $('.exhibition-sidebar ul li span');
    var $sidebarTop = $('#exhibition-sidebar-top');
    var $sidebarAbout = $('#exhibition-sidebar-about');
    var $sidebarLifestyle = $('#exhibition-sidebar-lifestyle');
    var $sidebarCollection = $('#exhibition-sidebar-collection');
    var $sidebarContents = $('#exhibition-sidebar-contents');
    var $sidebarPickup = $('#exhibition-sidebar-pickup');
    var $sidebarSpotify = $('#exhibition-sidebar-spotify');
    var $ncTopWrapper = $('.exhibition-nc-top-wrapper');
    var $c01NcRgihtWrapper = $('#collection01 .exhibition-nc-right-wrapper');
    var $c01NcRgihtImage = $('#collection01 .exhibition-nc-01-img');
    var $c02NcRgihtWrapper = $('#collection02 .exhibition-nc-right-wrapper');
    var $c02NcRgihtImage = $('#collection02 .exhibition-nc-02-img');
    var $c03NcRgihtWrapper = $('#collection03 .exhibition-nc-right-wrapper');
    var $c03NcRgihtImage = $('#collection03 .exhibition-nc-03-img');
    var $c04NcRgihtWrapper = $('#collection04 .exhibition-nc-right-wrapper');
    var $c04NcRgihtImage = $('#collection04 .exhibition-nc-04-img');
    var $c05NcRgihtWrapper = $('#collection05 .exhibition-nc-right-wrapper');
    var $c05NcRgihtImage = $('#collection05 .exhibition-nc-05-img');
    var $c06NcRgihtWrapper = $('#collection06 .exhibition-nc-right-wrapper');
    var $c06NcRgihtImage = $('#collection06 .exhibition-nc-06-img');
    var $c07NcRgihtWrapper = $('#collection07 .exhibition-nc-right-wrapper');
    var $c07NcRgihtImage = $('#collection07 .exhibition-nc-07-img');
    var $c08NcRgihtWrapper = $('#collection08 .exhibition-nc-right-wrapper');
    var $c08NcRgihtImage = $('#collection08 .exhibition-nc-08-img');
    var $exhibitionBlur = $('#exhibition-blur');
    var $contentsBlock = $('.exhibition-contents.exhibition-block');
    var $journalBlock = $('.exhibition-journal');
    // var $collabBlock = $('.exhibition-collab');
    var $catalogBlock = $('.exhibition-catalog.exhibition-block');
    var $pickupWrapper = $('.exhibition-pickup-wrapper');
    var $spotifyWrapper = $('.exhibition-spotify-wrapper');
    // var $queryWrapper = $('.exhibition-query-wrapper')
  
    if(windowWidth >= 1024 && windowHeight < windowWidth){
      $topWrapper.css(exhibitionTopTitle_props);
      $aboutWrapper.removeAttr('style');
    }

    $(window).scroll(function() {
      // ページのスクロール量を取得
      var scroll = $(this).scrollTop();
  
      // スクロールバー Fadeout
      if (scroll >= 5) {
        $scrollBar.css(fadeoutScrollBar);
      }
  
      // TOP タイトルのポップアップ
      if(windowWidth >= 1024 && windowHeight < windowWidth){
        if (scroll <= exhibitionAbout) {
          $topWrapper.css(exhibitionTopTitle_props);
          $aboutWrapper.removeAttr('style');
        }
        if (scroll > exhibitionFadeoutAbout) {
          $topWrapper.removeAttr('style');
          $aboutBox.removeAttr('style');
        }
        if (scroll < exhibitionNewCollection01) {
          $ncRightWrapper.removeAttr('style');
        }
        if (scroll >= exhibitionAboutTitlePosition) {
            $aboutWrapper.css('opacity',1);
            $topWrapper.removeAttr('style');
        }
      }

        // LifeStyle Titleのポップアップ
        // if (scroll >= exhibitionLifestyleBlank) {
        //     $lifestyleBlankWrapper.css(exhibitionLifeStyleTitle_props);
        // }else{
        //   if (scroll > exhibitionFadeoutFirstLifeStyle) {
        //   }else{
        //     $lifestyleBlankWrapper.removeAttr('style');
        //   }
        // }
        // if (scroll > exhibitionFadeoutFirstLifeStyle) {
        //   $lifestyleBlankWrapper.removeAttr('style');
        //   $lifestyleSecondBox.css("opacity",1);
          
        // }else{
        //   $lifestyleSecondBox.css("opacity",0);
        // }

        // RECREATIONの背景画像
        if( scroll >= exhibitionNewCollection07 ) {
          $lifestyleBackground.css("opacity",1)
          // $(".exhibition-special-movies-wrap").addClass("showed")
          $("#exhibition-lifestyle-bg").addClass("visible")
          $(".exhibition-new-store-wrap").removeClass("viewing")
        }else{
          $lifestyleBackground.removeAttr('style');
          // $(".exhibition-special-movies-wrap").removeClass("showed")
          $("#exhibition-lifestyle-bg").removeClass("visible")
          $(".exhibition-new-store-wrap").addClass("viewing")
        }

        // if(scroll >= exhibitionSpecialMovie){
        //   $(".exhibition-contents-wrap-new-store").addClass("showable")
        // }else{
        //   $(".exhibition-contents-wrap-new-store").removeClass("showable")
        // }

  
        // 言語変更ボタン色彩変更
        if(windowWidth >= 1024 && windowHeight < windowWidth){
            // if (scroll >= exhibitionNewCollection01 && scroll <= exhibitionContents) {
            //     $languageIcon.addClass("exhibition-language-icon-svg-black");
            //     $languageText.addClass("exhibition-language-text-black");
            //     $logoIcon.addClass("exhibition-logo-black");
            //     $spHeaderHmbgOpener.addClass("exhibition-opener-black");
                
            // }
            // if ((scroll < exhibitionNewCollection01 || scroll > exhibitionContents) && scroll < exhibitionContentsJournal) {
            //     $languageIcon.removeClass("exhibition-language-icon-svg-black");
            //     $languageText.removeClass("exhibition-language-text-black");
            //     $logoIcon.removeClass("exhibition-logo-black");
            //     $spHeaderHmbgOpener.removeClass("exhibition-opener-black");
            // }
            // if (scroll >= exhibitionContentsJournal) {
            //     $languageIcon.addClass("exhibition-language-icon-svg-black");
            //     $languageText.addClass("exhibition-language-text-black");
            //     $logoIcon.addClass("exhibition-logo-black");
            //     $spHeaderHmbgOpener.addClass("exhibition-opener-black");
            // }
            if (scroll >= exhibitionNewCollection01){
              $pcHeader.addClass("pc-header-background");
            }else{
              $pcHeader.removeClass("pc-header-background");
            }
        }else{
            // if (scroll >= exhibitionNewCollection01) {
            //     $languageButton.css("display","none");
            // }
            // if (scroll < exhibitionNewCollection01) {
            //     $languageButton.removeAttr("style");
            // }
            // if (scroll >= exhibitionNewCollection01){
            //   $spHeader.addClass("sp-header-background");
            // }else{
            //   $spHeader.removeClass("sp-header-background");
            // }
        }

        // サイドバー機能
        // currentPlaceによって、場合分け
        // 上から下にスクロールしていく場合
        // TOP部分
        if( scroll <= exhibitionSideAbout) {
            $sidebar.removeAttr('style');
            $sidebarLi.removeClass();
            $sidebarLiSpan.removeClass();
            $sidebarTop.addClass('exhibition-sidebar-active');
            // $sidebarAbout.removeClass('exhibition-sidebar-black exhibition-sidebar-active');
            $sidebarLi.removeClass('exhibition-sidebar-black');
            $sidebarLiSpan.removeClass('exhibition-sidebar-black');
        //  KINTO LOOP部分
        // } else if( scroll > exhibitionSideNewStore && scroll <= exhibitionSideCollection) {
        //     $sidebar.removeAttr('style');
        //     $sidebarLi.removeClass();
        //     $sidebarLiSpan.removeClass();
        //     $sidebarLifestyle.addClass('exhibition-sidebar-active');
            // $sidebarAbout.removeClass('exhibition-sidebar-black exhibition-sidebar-active');
            // $sidebarLi.addClass('exhibition-sidebar-black');
            // $sidebarLiSpan.addClass('exhibition-sidebar-black');
        // COLLECTION部分
        } else if (scroll > exhibitionSideCollection && scroll <= exhibitionSideNewCollection){
            $sidebarLi.removeClass();
            $sidebarLiSpan.removeClass();
            $sidebarCollection.addClass('exhibition-sidebar-active');
            $sidebarLifestyle.removeClass('exhibition-sidebar-active');
        // NEW COLLECTION部分
        } else if (scroll > exhibitionSideNewCollection && scroll <= exhibitionSideContents){
            $sidebarLi.removeClass();
            $sidebarLiSpan.removeClass();
            $sidebarAbout.removeClass('exhibition-sidebar-black exhibition-sidebar-active');
            $sidebarCollection.addClass('exhibition-sidebar-black exhibition-sidebar-active');
            $sidebarLi.addClass('exhibition-sidebar-black');
            $sidebarLiSpan.addClass('exhibition-sidebar-black');
        // CONTENTS部分
        // } else if (scroll > exhibitionSideContents && scroll <= exhibitionSideCollab){
        //   $sidebar.removeAttr('style');
        //   $sidebarLi.removeClass();
        //   $sidebarLiSpan.removeClass();
        //   $sidebarContents.addClass('exhibition-sidebar-black exhibition-sidebar-active');
        //   $sidebarLi.addClass('exhibition-sidebar-black');
        //   $sidebarLiSpan.addClass('exhibition-sidebar-black');
        //   // $sidebarContents.removeClass('exhibition-sidebar-active exhibition-sidebar-black');
        //   $sidebarLi.removeClass('exhibition-sidebar-black');
        //   $sidebarLiSpan.removeClass('exhibition-sidebar-black');
        // collab部分
        // } else if (scroll > exhibitionSideCollab && scroll <= exhibitionSideCatalog){
        //     $sidebar.removeAttr('style');
        //     $sidebarLi.removeClass();
        //     $sidebarLiSpan.removeClass();
        //     $sidebarContents.addClass('exhibition-sidebar-black exhibition-sidebar-active');
        //     $sidebarLi.addClass('exhibition-sidebar-black');
        //     $sidebarLiSpan.addClass('exhibition-sidebar-black');
            // $sidebarContents.removeClass('exhibition-sidebar-active');
        // Catalog部分
        } else if (scroll > exhibitionSideContents && scroll <= exhibitionSideSpotify){
            $sidebar.removeAttr('style');
            $sidebarLi.removeClass();
            $sidebarLiSpan.removeClass();
            $sidebarContents.addClass('exhibition-sidebar-black exhibition-sidebar-active');
            $sidebarLi.addClass('exhibition-sidebar-black');
            $sidebarLiSpan.addClass('exhibition-sidebar-black');
            // $sidebarContents.removeClass('exhibition-sidebar-active exhibition-sidebar-black');
            $sidebarLi.removeClass('exhibition-sidebar-black');
            $sidebarLiSpan.removeClass('exhibition-sidebar-black');
        } else if (scroll > exhibitionSideSpotify && scroll <= exhibitionSideFooterSide){
            $sidebar.removeAttr('style');
            $sidebarLi.removeClass();
            $sidebarLiSpan.removeClass();
            $sidebarPickup.addClass('exhibition-sidebar-black');
            $sidebarLi.addClass('exhibition-sidebar-black');
            $sidebarLiSpan.addClass('exhibition-sidebar-black');
            // $sidebarContents.removeClass('exhibition-sidebar-active exhibition-sidebar-black');
            // $sidebarLi.removeClass('exhibition-sidebar-black');
            // $sidebarLiSpan.removeClass('exhibition-sidebar-black');
        // FOOTER部分
        } else if (scroll > exhibitionSideFooterSide ){
            $sidebar.css({'position':'absolute','top': exhibitionSideFooter});
        }
  
        // FADEINとNEW COLLECTIONの固定
        if( scroll >= exhibitionFadeinAbout ) {
            $aboutWrapper.addClass('scrollin');
            $aboutBox.addClass('scrollin');
        }
        if( scroll <= exhibitionFadeinAbout ) {
            $aboutWrapper.removeClass('scrollin');
            $aboutBox.removeClass('scrollin');
        }

        // if( scroll >= exhibitionFadeinHistory ){
        //   $historyFadeIn.addClass('scrollin');
        // }

        // if( scroll >= exhibitionFadeinSpecialMovie ) {
        //     $specialMovie.addClass('scrollin');
        // }
        if( scroll >= exhibitionFadeinNewStore ) {
            $newStore.addClass('scrollin');
        }
        if (scroll >= exhibitionFadeinCollection){
            $ncTopWrapper.addClass('scrollin');
        }
        if (scroll >= exhibitionFadeinNewCollection01){
            $c01NcRgihtWrapper.addClass('scrollin');
            $c01NcRgihtImage.addClass('scrollin-collection');
        }
        if (scroll >= exhibitionFadeinNewCollection02){
            $c02NcRgihtWrapper.addClass('scrollin');
            $c02NcRgihtImage.addClass('scrollin-collection');
        }
        if (scroll >= exhibitionFadeinNewCollection03){
            $c03NcRgihtWrapper.addClass('scrollin');
            $c03NcRgihtImage.addClass('scrollin-collection');
        }
        if (scroll >= exhibitionFadeinNewCollection04){
            $c04NcRgihtWrapper.addClass('scrollin');
            $c04NcRgihtImage.addClass('scrollin-collection');
        }
        if (scroll >= exhibitionFadeinNewCollection05){
          $c05NcRgihtWrapper.addClass('scrollin');
          $c05NcRgihtImage.addClass('scrollin-collection');
        }
        if (scroll >= exhibitionFadeinNewCollection06){
          $c06NcRgihtWrapper.addClass('scrollin');
          $c06NcRgihtImage.addClass('scrollin-collection');
        }
        if (scroll >= exhibitionFadeinNewCollection07){
          $c07NcRgihtWrapper.addClass('scrollin');
          $c07NcRgihtImage.addClass('scrollin-collection');
        }
        if (scroll >= exhibitionFadeinNewCollection08){
          $c08NcRgihtWrapper.addClass('scrollin');
          $c08NcRgihtImage.addClass('scrollin-collection');
        }
        if (scroll >= exhibitionFadeinContents){
            $contentsBlock.addClass('scrollin');
        }
        if (scroll >= exhibitionFadeinContentsJournal){
            $journalBlock.addClass('scrollin');
        }
        // if (scroll >= exhibitionFadeinContentsCollab){
        //     $collabBlock.addClass('scrollin');
        // }
        if (scroll >= exhibitionFadeinContentsCatalog){
            $catalogBlock.addClass('scrollin');
        }
        if (scroll >= (exhibitionFadeinPickup)){
            $pickupWrapper.addClass('scrollin');
        }
        if (scroll >= (exhibitionFadeinSpotify)){
            $spotifyWrapper.addClass('scrollin');
        }
        // if (scroll >= (exhibitionFadeinQuery)){
        //     $queryWrapper.addClass('scrollin');
        // }
  
        // 背景黒フィルター追加
        if (scroll >= exhibitionFadeinAbout && scroll < exhibitionNewCollection01) {
          if($exhibitionBlur.hasClass('hasWhite_props')){
            $exhibitionBlur.removeClass();
          }
          $exhibitionBlur.addClass('hasBlur_props');
        }
  
        if (scroll < exhibitionFadeinAbout ) {
          $exhibitionBlur.removeClass();
        }
        // if(scroll > exhibitionSpecialMovie){
        //     $exhibitionBlur.removeClass();
        // }
        // if(scroll > exhibitionLifestyleBlank){
        //     $exhibitionBlur.addClass('hasBlur_props');
        // }
  
        // 背景白フィルター追加
        // if (scroll >= exhibitionNewCollection02 && scroll < exhibitionFadeinNewCollection08) {
        //   if($exhibitionBlur.hasClass('hasBlur_props') || $exhibitionBlur.hasClass('hasBg_props')){
        //     $exhibitionBlur.removeClass();
        //     $exhibitionBlur.addClass('hasWhite_props');
        //   }
        // }
        
        // // 背景静止画像セット
        // if (scroll >= exhibitionFadeinNewCollection08 && scroll < exhibitionContentsJournal ) {
        //   if($exhibitionBlur.hasClass('hasWhite_props')){
        //     $exhibitionBlur.removeClass();
        //     $exhibitionBlur.addClass('hasBg_props');
        //   }else{
        //     $exhibitionBlur.addClass('hasBg_props');
        //   }
        // }

        // 背景静止画像除去
        // if (scroll >= exhibitionContentsCatalog ) {
        //     // $exhibitionBlur.removeClass();
        // }
  
    });
  
    // slick
    // LINE UPの画像部分は常に初期化
    $('.exhibition-auto-slick').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      dots: true,
      arrows: true,
      prevArrow: '<button type="button" class="slide-arrow slick-prev"></button>',
      nextArrow: '<button type="button" class="slide-arrow slick-next"></button>',
      fade: true,
      easing: "swing",
      speed: 1000
    });
  
    // 背景画像のスライダーはBACKGROUND VIDEOが設定されていない場合のみ初期化
    if ($('.exhibition-bg-movie video').length === 0) {
      $('.exhibition-auto-slick-sp').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        arrows: false,
        fade: true,
        easing: "swing",
        speed: 1000
      });
    }

    // $('.exhibition-new-store-box').slick({
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     autoplay: true,
    //     autoplaySpeed: 4000,
    //     arrows: true,
    //     prevArrow:'<button type=”button” class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0076/8747/1170/files/arrow.png?v=1636703182"></button>',
    //     nextArrow:'<button type=”button” class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0076/8747/1170/files/arrow_155753df-aafc-4d9f-ab5a-26b3ade4b028.png?v=1636703201"></button>',
    //     dots: true,
    //     fade: true,
    //     easing: "swing",
    //     speed: 1000
    // });
  
    // modal
    $('.modaal-inside-video').modaal({
      before_open: myFunction,
      type: 'video',
      background_scroll: true,
      before_close: function() {
        $(window).scrollTop(sc);
      }
    });

    $('.special-movie-modaal').modaal({
      before_open: myFunction,
      type: 'video',
      background_scroll: true,
      before_close: function() {
        $(window).scrollTop(sc);
      }
    });

  
    // モーダル閉じるとTOPに戻るため、事前にスクロール量取得し、閉じた後にスクロール量固定
    function myFunction() {
      sc = $(window).scrollTop();
    }

    // SWIPER
    var getTranslate;
    var slideWidth;

    // POINTER
    var cursor = $("#cursor");

    // ヘッダー制御
    $(".open-hbg-menu").on("click", function(){
      $(".sp-header-content").show();
    });
    $(".sp-header-content-top-right").on("click", function(){
      $(".sp-header-content").hide();
    });
    $(".sp-header-content a").on("click", function(){
      $(".sp-header-content").hide();
    });
})
